module.exports = __webpack_public_path__ + "img/8f5b60ef00714a399ee544d331231820.852dafa9.jpeg";